import { ReactNode } from 'react';
import { cx } from 'class-variance-authority';
import { Logo } from './logo';

export function CenteredContainer({
  preferredWidth = '26rem',
  hideLogo,
  children,
}: {
  preferredWidth?: string;
  hideLogo?: boolean;
  children: ReactNode;
}) {
  return (
    <>
      <div className="mb-4 self-end justify-self-center md:mb-8">
        {!hideLogo && <Logo className="max-w-full" width="320" />}
      </div>
      <div
        style={{ '--preferred-width': preferredWidth }}
        className={cx(
          'w-[min(var(--preferred-width),100%)]',
          'grid gap-6 justify-self-center',
          'rounded-lg bg-default shadow-xl',
          'px-6 py-8 md:px-[3rem]',
        )}
      >
        {children}
      </div>
    </>
  );
}
